// extracted by mini-css-extract-plugin
module.exports = {"hosting":"Hosting_hosting___HgxB","details_opener":"Hosting_details_opener__s1MyH","hosting_item":"Hosting_hosting_item__WhH9p"};